import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@contexts/AuthContext';
import ProtectedRoute from '@components/ProtectedRoute';

import NotFoundPage from '@pages/NotFoundPage';
import LoginPage from '@pages/LoginPage';
import HomePage from '@pages/HomePage';
import AccountPage from '@pages/AccountPage';
import WorkflowListPage from '@pages/WorkflowListPage';
import WorkflowCreatePage from '@pages/WorkflowCreatePage';
import WorkflowEditPage from '@pages/WorkflowEditPage';
import UserListPage from '@pages/UserListPage';
import UserCreatePage from '@pages/UserCreatePage';
import UserEditPage from '@pages/UserEditPage';
import CustomerListPage from '@pages/CustomerListPage';
import CustomerCreatePage from '@pages/CustomerCreatePage';
import CustomerEditPage from '@pages/CustomerEditPage';
import CustomerIntegrationsPage from '@pages/CustomerIntegrationsPage';
import MailingListListPage from './pages/MailingListListPage';
import MailingListEditPage from './pages/MailingListEditPage';
import SendoutListPage from './pages/SendoutListPage';
import SendoutEditPage from './pages/SendoutEditPage';
import SendoutContactPage from './pages/SendoutContactPage';
import PackListPage from './pages/PackListPage';
import MyPacksPage from './pages/MyPacksPage';
import ForgotPasswordPage from '@pages/ForgotPasswordPage';
import ResetPasswordPage from '@pages/ResetPasswordPage';
import ChangePasswordPage from '@pages/ChangePasswordPage';
import AuthPage from '@pages/AuthPage';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth" element={<AuthProvider><AuthPage /></AuthProvider>} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<AuthProvider><ProtectedRoute role="user" doNotCheckPasswordChange><ChangePasswordPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/" element={<AuthProvider><ProtectedRoute role="user"><HomePage /></ProtectedRoute></AuthProvider>} />
        <Route path="/account" element={<AuthProvider><ProtectedRoute role="user"><AccountPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/workflows/templates" element={<AuthProvider><ProtectedRoute role="user"><WorkflowListPage type="templates" /></ProtectedRoute></AuthProvider>} />
        <Route path="/workflows/custom" element={<AuthProvider><ProtectedRoute role="user"><WorkflowListPage type="custom" /></ProtectedRoute></AuthProvider>} />
        <Route path="/workflows/templates/create" element={<AuthProvider><ProtectedRoute role="superadmin"><WorkflowCreatePage type="templates" /></ProtectedRoute></AuthProvider>} />
        <Route path="/workflows/custom/create" element={<AuthProvider><ProtectedRoute role="user"><WorkflowCreatePage type="custom" /></ProtectedRoute></AuthProvider>} />
        <Route path="/workflows/templates/:id" element={<AuthProvider><ProtectedRoute role="user"><WorkflowEditPage type="templates" /></ProtectedRoute></AuthProvider>} />
        <Route path="/workflows/custom/:id" element={<AuthProvider><ProtectedRoute role="user"><WorkflowEditPage type="custom" /></ProtectedRoute></AuthProvider>} />

        <Route path="/users" element={<AuthProvider><ProtectedRoute role="admin"><UserListPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/users/create" element={<AuthProvider><ProtectedRoute role="admin"><UserCreatePage /></ProtectedRoute></AuthProvider>} />
        <Route path="/users/:id" element={<AuthProvider><ProtectedRoute role="admin"><UserEditPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/customers" element={<AuthProvider><ProtectedRoute role="superadmin"><CustomerListPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/customers/create" element={<AuthProvider><ProtectedRoute role="superadmin"><CustomerCreatePage /></ProtectedRoute></AuthProvider>} />
        <Route path="/customers/:id" element={<AuthProvider><ProtectedRoute role="superadmin"><CustomerEditPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/customers/:customerId/packs/:type" element={<AuthProvider><ProtectedRoute role="superadmin"><PackListPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/customers/:customerId/integrations" element={<AuthProvider><ProtectedRoute role="superadmin"><CustomerIntegrationsPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/packs/:type" element={<AuthProvider><ProtectedRoute role="user"><MyPacksPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/mailinglists" element={<AuthProvider><ProtectedRoute role="user"><MailingListListPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/mailinglists/:id" element={<AuthProvider><ProtectedRoute role="user"><MailingListEditPage /></ProtectedRoute></AuthProvider>} />

        <Route path="/sendouts" element={<AuthProvider><ProtectedRoute role="user"><SendoutListPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/sendouts/:id" element={<AuthProvider><ProtectedRoute role="user"><SendoutEditPage /></ProtectedRoute></AuthProvider>} />
        <Route path="/sendouts/:sendoutId/contacts/:contactId" element={<AuthProvider><ProtectedRoute role="user"><SendoutContactPage /></ProtectedRoute></AuthProvider>} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
